import DeleteIcon from './component'

export default DeleteIcon
